import { Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps } from '@mantine/core'
import innertext from 'innertext'

import { handleScrollToBlock } from 'components/templates/carePath/helpers'
import { useIsMobile } from 'hooks/useIsMobile'
import { HealthToolByCategory } from 'interfaces/types'

import useStyles from './index.styles'
import { ScrollAreaNav } from 'components/molecules/scrollAreaNav'

type Props = {
  options: HealthToolByCategory[]
  visibleSection: string
} & BoxProps

export const HealthToolsNav = ({
  options,
  visibleSection,
  styles,
  classNames,
  className,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'HealthToolsNav',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()

  return (
    <ScrollAreaNav
      classNames={{
        root: cx(className, classes.nav),
      }}
      {...rest}
    >
      {options.map((i, idx) => (
        <Text
          size="s3"
          weight="semiBold"
          key={idx}
          color="#8C8C8C"
          // data-section-id={i.termId.toString()}
          className={cx(
            visibleSection === i.termId.toString() ? 'selected' : '',
            classes.navItem,
          )}
          onClick={() =>
            handleScrollToBlock({
              hash: i.termId.toString(),
              isMobile,
            })
          }
        >
          {innertext(i.name)}
        </Text>
      ))}
    </ScrollAreaNav>
  )
}
